import * as MuiIconButton from '@mui/material/IconButton'
import React from 'react'

export type IconButtonProps = MuiIconButton.IconButtonProps

export function IconButton({ children, ...props }: IconButtonProps) {
  return <MuiIconButton.default {...props}>{children}</MuiIconButton.default>
}
